import { useCallback } from 'react'
import { useSWRConfig } from 'swr'

const API_URL = import.meta.env.VITE_API_URL

export const useClearCache = () => {
  const { mutate } = useSWRConfig()

  const clearCache = useCallback(
    (paths: string | string[]) => {
      const pathsArray = Array.isArray(paths) ? paths : [paths]
      const fullUrls = pathsArray.map((path) => `${API_URL}${path}`)

      mutate(
        (key: unknown) => {
          if (typeof key !== 'object' || key === null || !('url' in key)) return false
          const url = (key as { url: unknown }).url
          if (typeof url !== 'string') return false
          return fullUrls.some((fullUrl) => url === fullUrl || url.startsWith(`${fullUrl}?`))
        },
        undefined,
        { revalidate: true },
      )
    },
    [mutate],
  )

  return { clearCache }
}
